import React, { useMemo } from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { policyOptionsSelector, formViewSelector } from '@store/policies/schedule/selectors';
import { setPolicies } from '@store/policies/schedule/actions';
import { formModes } from '@store/policies/schedule/formReducer';
import { FieldWrapper } from './styled';

const { Option, OptGroup } = Select;

function PolicyMultiSelect() {
  const policyOptions = useSelector(policyOptionsSelector);
  const { mode, policies } = useSelector(formViewSelector);
  const dispatch = useDispatch();

  const children = useMemo(
    () =>
      policyOptions.map((policy) => (
        <OptGroup key={policy.id} label={policy.title}>
          {policy.versions.map((version) => {
            const styles = version.active ? { color: '#8bc34a' } : {};
            return (
              <Option
                key={version.id}
                value={version.id}
                title={version.title}
                disabled={policy.selected ? !version.selected : false}
                style={styles}
              >
                {version.title}
              </Option>
            );
          })}
        </OptGroup>
      )),
    [policyOptions],
  );

  function handleChange(value) {
    dispatch(setPolicies(value));
  }

  return (
    <FieldWrapper>
      <Select
        mode="multiple"
        style={{ width: '100%' }}
        placeholder="Search and Select Policies"
        defaultValue={policies}
        onChange={handleChange}
        allowClear
        optionFilterProp="title"
        disabled={mode === formModes.delete}
      >
        {children}
      </Select>
    </FieldWrapper>
  );
}

export default React.memo(PolicyMultiSelect);
